import i18nInst from "i18next";
import Backend, { type ChainedBackendOptions } from "i18next-chained-backend";
import HttpApi from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import { initReactI18next } from "react-i18next";

import {
  API_BASE_LANDINGS,
  apiBaseUrl,
  getI18nCacheExpirationMs,
  getLangLocalStorage,
  LANG_DEFAULT,
  LANGS_SUPPORTED,
  Log,
  normalizeUrlBasePath,
  syncI18nCacheWithApiVersion,
  type SupportedLanguage,
} from "@ryde/shared";

const initialStoredLanguage: SupportedLanguage =
  getLangLocalStorage() || LANG_DEFAULT;

Log.debug("API BASE URL", apiBaseUrl());
const loadPathLandings =
  normalizeUrlBasePath(apiBaseUrl() || "") +
  `${API_BASE_LANDINGS}/i18n/{{lng}}`;
Log.debug(
  `Load path for translations: ${loadPathLandings}, base path: ${apiBaseUrl()}`,
);

i18nInst
  .use(Backend)
  .use(initReactI18next)
  .init<ChainedBackendOptions>({
    load: "languageOnly",
    returnNull: false,
    backend: {
      backends: [
        LocalStorageBackend, // primary
        HttpApi, // fallback
      ],
      backendOptions: [
        {
          expirationTime: getI18nCacheExpirationMs(),
        },
        {
          loadPath: loadPathLandings,
        },
      ],
    },
    lng: initialStoredLanguage,
    fallbackLng: LANG_DEFAULT,
    supportedLngs: LANGS_SUPPORTED,
    nsSeparator: ":",
    keySeparator: ".",
    ns: ["general", "landing"],
    defaultNS: "general",
    // The core bootstrap, imported through @ryde/shared, sets a fallback namespace this app never loads.
    fallbackNS: false,
    debug: false, //!isProductionEnv(),
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  })
  .then(() => {
    Log.debug("Languages for landings initialized", initialStoredLanguage);

    return syncI18nCacheWithApiVersion(API_BASE_LANDINGS);
  })
  .catch(err => {
    Log.error(
      "An error occurred while initializing landing translations: ",
      err,
    );
  });
export default i18nInst;
